export default __webpack_public_path__ + "assets/img/nudge_2.jpg";